<template>
  <div class="AddonPriceBreakdown">
    <div class="AddonPriceBreakdown-row">
      <span class="AddonPriceBreakdown-label">{{ t('ui.global.outbound') }}</span>
      <span class="AddonPriceBreakdown-separator" aria-hidden="true" />
      <span class="AddonPriceBreakdown-price">{{ outboundPrice }}</span>
    </div>

    <div class="AddonPriceBreakdown-row">
      <span class="AddonPriceBreakdown-label">{{ t('ui.global.inbound') }}</span>
      <span class="AddonPriceBreakdown-separator" aria-hidden="true" />
      <span class="AddonPriceBreakdown-price">{{ inboundPrice }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@cvo/i18n/composables/useI18n';

interface Props {
  outboundPrice: string;
  inboundPrice: string;
}

defineProps<Props>();

const { t } = useI18n();

</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .AddonPriceBreakdown {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-3;
    padding: vars.$dimensions-d-2;
    background-color: vars.$organisms-card-add-onpricing-card-bg-color;
    border: vars.$organisms-card-add-onpricing-card-border-stroke solid vars.$organisms-card-add-onpricing-card-border-color;
    border-radius: vars.$organisms-card-add-onpricing-card-border-radius;
    min-width: 200px;

    &-row {
      display: flex;
      align-items: center;
      gap: vars.$dimensions-d-1;
      width: 100%;
    }

    &-label {
      flex-shrink: 0;
      color: vars.$organisms-card-add-onpricing-segment-text-color;
      letter-spacing: -0.03em;
      @include text.text('xs');
    }

    &-separator {
      flex: 1;
      min-inline-size: 0;
      block-size: 0;
      border-block-start: 1px dashed vars.$organisms-card-add-onpricing-card-border-color;
    }

    &-price {
      flex-shrink: 0;
      color: vars.$organisms-card-add-onpricing-price-color;
      letter-spacing: -0.03em;
      @include text.text('xs', vars.$typography-weight-strong);
    }
  }
}
</style>
